import { useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { twMerge } from "tailwind-merge";
import { departmentService } from "../../services/department.service";
import {
  GetDepartmentList,
  SetDepartmentList,
} from "../../store/departmentAtom";

function DepartmentSideScroll({ viewDepartmentDetails }) {
  const setDepartmentList = SetDepartmentList();
  const departmentList = GetDepartmentList();
  const { id } = useParams();
  const selectedCardRef = useRef(null);

  useEffect(() => {
    if (!departmentList.loaded && departmentList.departments.length < 1) {
      departmentService.getDepartments().then((res) => {
        setDepartmentList({
          departments: res.departments,
          raw: res.raw,
          loaded: true,
        });
      });
    }
  }, [departmentList.loaded, departmentList.departments.length, setDepartmentList]);

  useEffect(() => {
    selectedCardRef.current?.scrollIntoView({
      block: "nearest",
      behavior: "smooth",
    });
  }, [id, departmentList.departments.length]);

  return (
    <div className="w-full h-screen p-2 border-[1px] border-gray-200 rounded-lg overflow-y-auto scrollbar-thumb-gray-400 scrollbar-thin scrollbar-track-gray-200">
      {departmentList.departments.map((department, index) => {
        const selected = String(id) === String(department.id);

        return (
          <div
            ref={selected ? selectedCardRef : null}
            className={twMerge(
              "border px-2 py-3 cursor-pointer border-gray-200 transition-colors",
              selected ? "bg-gray-200" : "hover:bg-gray-100"
            )}
            key={department.id || index}
            onClick={() => viewDepartmentDetails(department.id)}
          >
            <div className="text-sm font-semibold text-gray-700 truncate">
              {department.name}
            </div>
            <div className="mt-1 text-xs font-medium text-gray-500">
              {department.statusLabel}
            </div>
          </div>
        );
      })}

      {departmentList.loaded && departmentList.departments.length < 1 ? (
        <div className="p-4 text-sm text-gray-500">No departments found</div>
      ) : null}
    </div>
  );
}

export default DepartmentSideScroll;
